export default __webpack_public_path__ + "static/media/Timbres_.0793646b.bmp";